import React from 'react'
import styles from '../style'

const divider = () => {
  return (
    <div className='w-full text-white three-gradient h-px my-20'></div>
  )
}

export default divider